const setActiveTab = (state, payload) => {
  state.activeTabView = payload
}

export default {
  setActiveTab,
}
